import gql from "graphql-tag";
import candidateFragment from "./../../candidate/graphql/CandidateFragment";
import clientFragment from "./../../client/graphql/ClientFrangment";

export default gql `{
  id
  available
  candidacies {
    id
    appliedFor
    candidate {
      ...${candidateFragment}
    }
    stages {
      name
      analyze
      rating
      startDate
      startTime
      endDate
      endTime
    }
    notes {
      name
      text
      time
    }
    tests {
      id
      candidate
      date
      description
      image
      questions {
        question
        objective
        implication
        file
        fileResponse
        openQuestion
        alternatives {
          answer
          response
          value
          textResponse
        }
        observations{
          id:_id
          name
          time
          result
          textObservation
        }
        answer
        totalCorrect
        percentage
        picture
      }
      result
      status
      time
      title
      type
      # user {
      #   id
      #   name
      #   office
      #   photo
      # }
      vacancy {
        id
      }
    }
    favorite
    status
  }
  client {
    ...${clientFragment}
  }
  description 
  entity {
    id
    logo
    name
    about
    media{
      facebook
      linkedin
      twitter
    }
  }
  finalDate
  formation {
    course
    level
    status
    institution
    year
    weight
  }
  languages {
    name
    level
    weight
  }
  documents {
    name
    rule
  }
  areaInterest
  weight
  locale
  category
  place
  private
  professionalExperience {
    description
    yearsExperience
    sector
    weight
  }
  publicationDate
  status
  title
  type
  views
  stages {
    name
    analyze
    startDate
    startTime
    endDate
    endTime
   
  }
}`;